import React, { useState, useEffect, useContext } from "react"
import { Input as CoreInput } from "@stardust-ds/react"
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import AuthContext from "../../../contexts/Auth"
import Table from "../../atoms/Table"
import SearchIcon from "../../../assets/icons/SearchIcon"
import useDataApi from "../../../hooks/useDataApi"
import { fnGetActivityHistory } from "../../../services/acitivities"
import { fnFormatDate, fnFormatDateFromUTC, fnIsValidDate } from "../../../utils/date"
import RcmpLoading from "../../atoms/Loading"
import InfiniteScroll from "../../atoms/InfiniteScroll"
import { debounce } from "../../../utils/debounce"
import { fnUtf8Decode } from "../../../utils/string"

function RcmpActivityHistory(props) {
    const { oCurrentActivity } = props

    const { oUser } = useContext(AuthContext)
    const cUserTimeZone = oUser?.data?.user_ctimezone
    const [oActivityHistoryRes, fnActivityHistoryReq] = useDataApi(fnGetActivityHistory)
    const [aHistory, fnSetAHistory] = useState([])
    const [oParams, fnSetOParams] = useState({ cSearchTerm: "", nPage: 1 })

    async function fnGetActivityHistoryWithParams() {
        const nActivityId = oCurrentActivity?.opat_nid

        if (!nActivityId || oActivityHistoryRes?.loading) return

        if (oParams.nPage === 1) fnSetAHistory([])

        const cParams = `page=${oParams.nPage}&search=${oParams?.cSearchTerm || ""}`
        const response = await fnActivityHistoryReq(nActivityId, cParams)
        fnSetAHistory(oldAHistory => [...oldAHistory, ...(response?.data?.data || [])]);
    }

    useEffect(() => {
        (async () => {
            await fnGetActivityHistoryWithParams()
        })()
    }, [oParams])

    function fnNextPage(nPage) {
        fnSetOParams((prev) => ({ ...prev, nPage }))
    }

    function fnHandleOnChangeSearch(e) {
        const cSearchTerm = e?.target?.value
        fnSetOParams({ cSearchTerm, nPage: 1 })
    }

    function fnHandleFieldChange(oHistory) {
        if (!oHistory?.opah_cprevious_value && !oHistory?.opah_cnew_value) return

        let previousValue = oHistory?.opah_cprevious_value
        let newValue = oHistory?.opah_cnew_value
        if (fnIsValidDate(previousValue)) previousValue = fnFormatDate(previousValue, "DD/MM/YYYY")
        if (fnIsValidDate(newValue)) newValue = fnFormatDate(newValue, "DD/MM/YYYY")

        return (
            <>
                {previousValue?.length > 0 && (<><strong>de</strong> {previousValue} </>)}
                {newValue?.length > 0 && (<><strong>para</strong> {newValue}</>)}
            </>
        )
    }

    return (
        <div className={styles.historyContainer}>
            <CoreInput
                isFullWidth
                height={64}
                bColor={"#fff"}
                className={styles.inputSearch}
                placeholder={intl.get("ActivityHistory.search_history")}
                onChange={debounce((e) => fnHandleOnChangeSearch(e), 1000)}
                iconLeft={<SearchIcon />}
            />
            <InfiniteScroll
                fnNext={fnNextPage}
                nTotalPages={oActivityHistoryRes?.data?.data?.last_page}
                nDataLength={aHistory.length}
                bStopPagination={oActivityHistoryRes?.error || oActivityHistoryRes?.loading}
                scrollableTarget="modal-overflow-content"
            >
                {(aHistory?.length > 0) && (
                    <Table bHideArrow={true}>
                        <Table.THead>
                            <Table.HeadData>{intl.get("ActivityHistory.date")}</Table.HeadData>
                            <Table.HeadData>{intl.get("ActivityHistory.user")}</Table.HeadData>
                            <Table.HeadData>{intl.get("ActivityHistory.type")}</Table.HeadData>
                            <Table.HeadData>{intl.get("ActivityHistory.change")}</Table.HeadData>
                        </Table.THead>
                        <Table.TBody>
                            {aHistory?.map(oHistory => (
                                <Table.TRow key={oHistory?.opah_nid}>
                                    <Table.TData style={{ minWidth: 110 }}>{fnFormatDateFromUTC(oHistory?.opah_dcreated, "DD/MM/YYYY - HH:mm", cUserTimeZone)}</Table.TData>
                                    <Table.TData>{oHistory?.user?.user_cname}</Table.TData>
                                    <Table.TData>{oHistory?.type?.opht_cname}</Table.TData>
                                    <Table.TData>{fnUtf8Decode(oHistory?.opah_cdescription)} {fnHandleFieldChange(oHistory)}</Table.TData>
                                </Table.TRow>
                            ))}
                        </Table.TBody>
                    </Table>
                )}
            </InfiniteScroll>
            <RcmpLoading bShow={oActivityHistoryRes.loading} />
        </div>
    )
}

export default RcmpActivityHistory